import React from 'react';
import classnames from 'classnames';
import { Button, Form, Modal, ModalBody, ModalHeader } from '../../../components/Bootstrap';
import { IndicatorDot, Chevron } from '../../../components';
import { ManagerModalProps, FufillmentCenterModalStep } from './types';
import { steps } from './Steps';
import './ManagerModal.scss';
import { CenterModel } from '../types';

export const ManagerModal: React.FC<ManagerModalProps> = ({ initilalData, ...props }) => {
  const [stepIndex, setStepIndex] = React.useState(0);
  const [data, setData] = React.useState<CenterModel>(initilalData);
  React.useEffect(() => {
    setData(initilalData);
    setStepIndex(0);
  }, [initilalData]);

  const relevantSteps: FufillmentCenterModalStep[] = React.useMemo(() => {
    return steps.filter((s) => (s.showIf && data ? s.showIf(data) : true));
  }, [data]);

  const onNextStep = (e) => {
    e.preventDefault();
    if (stepIndex < relevantSteps.length - 1) {
      setStepIndex(stepIndex + 1);
    } else {
      props.onSubmit(data);
    }
  };

  const onPrevStep = () => {
    if (stepIndex > 0) {
      setStepIndex(stepIndex - 1);
    } else {
      props.onCancel();
    }
  };

  const goToStep = (i) => {
    if (i < stepIndex) {
      setStepIndex(i);
    }
  };

  const step = relevantSteps[stepIndex];

  const className = 'fulfillment-center-modal modal-dialog-centered';

  const submitButtonText = stepIndex === relevantSteps.length - 1 ? 'Finish' : 'Next';
  const cancelButtonText = stepIndex === 0 ? 'Cancel' : 'Previous';

  return (
    <Modal size='lg' className={className} isOpen={props.open} toggle={props.onCancel}>
      <ModalHeader className='justify-content-center'>{step.name}</ModalHeader>
      <ModalBody>
        <p className='fulfillment-center-modal-desc'>{step.description}</p>
        <Form onSubmit={onNextStep}>
          <div className='mt-md-5 mb-md-5 mt-3'>{data && step.component(data, setData, props)}</div>
          <div className='text-center fulfillment-center-modal-btns'>
            <Chevron
              direction='left'
              className={classnames(
                'fulfillment-center-modal-back-chevron',
                stepIndex > 0 && 'fulfillment-center-modal-back-chevron-prev'
              )}
              onClick={onPrevStep}
            />
            <Button
              type='button'
              color='link'
              className={classnames(
                'fulfillment-center-modal-cancel',
                stepIndex === 0 && 'fulfillment-center-modal-cancel-first'
              )}
              onClick={onPrevStep}
            >
              {cancelButtonText}
            </Button>{' '}
            <Button type='submit' color='primary' className='btn--rounded-padded fulfillment-center-modal-submit'>
              {submitButtonText}
            </Button>
          </div>
          <div className='d-flex justify-content-center mt-4 mb-4'>
            {relevantSteps.map((_, i) => (
              <IndicatorDot data={i} onClick={goToStep} key={i} active={i === stepIndex} />
            ))}
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
